export default "/images/vendor/flag-icon-css/flags/1x1/hn.svg?5ef17b2e2f89d5d559b9c5f0c3e978b9";